<div class="cell auto grid-x align-center align-middle login">
    <div class="cell auto loginIntro">
        <h1 class="loginIntro-title" [i18nKey]="'login.title'"></h1>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <p class="loginIntro-description" [i18nKey]="'login.description'"></p>
    </div>
    <!-- END Login Description !-->


    <!-- Login Form !-->
    <div class="cell auto loginForm">
        <div class="loginForm-header">
            <h2 class="title" [i18nKey]="'login.connect.title'"></h2>
            <span class="logo"></span>
        </div>

        <form class="loginForm-content" (ngSubmit)="authenticate(login, password)">
            <!-- Id -->
            <label><span [i18nKey]="'login.username.label'"></span>
                <input type="text"
                       [i18nKey]="[{target: 'attribute:placeholder', key: 'login.username.placeholder'}]"
                       [(ngModel)]="login"
                       name="login"
                       required />
            </label>
            <!-- END Id -->

            <kiwi-spacer [size]="16"></kiwi-spacer>

            <!-- Login -->
            <label><span [i18nKey]="'login.password.label'"></span>
                <input [type]="isPasswordClear? 'text' : 'password'"
                       [placeholder]="'login.password.placeholder'|translate" [i18nKey]="[{target: 'attribute:placeholder', key: 'login.password.placeholder'}]"
                       [(ngModel)]="password"
                       name="password"
                       required/>
            </label>

            <!-- Password -->
            <span class="showPasswordButton"
                  (click)="togglePassword()">
                 {{(isPasswordClear ? 'login.hide.password' : 'login.show.password') | translate}}
            </span>

            <!-- END Password -->

            <button class="button _fullBtn" type="submit" name="authenticate" [disabled]="!login || !password"[i18nKey]="'login.login'"></button>

            <a class="small-12 columns missingPass" (click)="showForgottenPasswordPopup(login)"[i18nKey]="'login.forgotten.password'"></a>
        </form>
    </div>
    <!-- END Login Form !-->
</div>
